// @flow
import * as React from 'react';

export default function LockIcon(props) {
    return (<svg {...props} width="20px" height="22px" viewBox="0 0 20 22" version="1.1">
        <path fill="#333" fillRule="nonzero" d="M12,17c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,8h-1L17,6c0,-2.76 -2.24,-5 -5,-5S7,3.24 7,6v2L6,8c-1.1,0 -2,0.9 -2,2v10c0,1.1 0.9,2 2,2h12c1.1,0 2,-0.9 2,-2L20,10c0,-1.1 -0.9,-2 -2,-2zM8.9,6c0,-1.71 1.39,-3.1 3.1,-3.1s3.1,1.39 3.1,3.1v2L8.9,8L8.9,6zM18,20L6,20L6,10h12v10z"></path>
    </svg>);
}



// WEBPACK FOOTER //
// ./src/Reengagement/LockIcon.jsx